export function createTextBox(setDataFromId,title,type,viewtype,isContact){
	let result = createDataBox(setDataFromId,title,type,viewtype,isContact);
	result.childNodes[0].childNodes[0].required = true;
	result.childNodes[0].childNodes[0].type = "text";
	return result;
}


export function createGeoBox(setDataFromId,title,type,viewtype,isContact){
	let f = (e) => {
		document.getElementById('teamList'+type).innerHTML = "";
		let query = document.getElementById(e).value;
		if (query.length >= 2){
			$.get( "https://api.vermflex.ch/offerservice/communes/", {search:query} )
				.done(function( search ) {
					if ( !(document.getElementById(e).dataset.valid && search.find(x => x.name === query) !== undefined )){
						document.getElementById('teamList'+type).innerHTML = "";
						search.forEach( x=> document.getElementById('teamList'+type).innerHTML += "<option>"+x.name+"</option>");
					}
					if (search.length == 1 || search.map(x=> x.name).includes(query)) {
						document.getElementById(e).dataset.valid = true;
						setDataFromId(type,viewtype);
					} else if (search.length == 0){
						document.getElementById(e).value = "";
						document.getElementById(e).dataset.valid = false;
					} 
				})
				.fail(function(){
					document.getElementById(e).value = "";
					document.getElementById(e).dataset.valid = false;
				});
		} else {
				document.getElementById(e).dataset.valid = false;
		}
	}

	let result = createDataBox(f,title,type,viewtype,isContact);
	result.childNodes[0].childNodes[0].required = true;
	result.childNodes[0].childNodes[0].type = "text";
	result.childNodes[0].childNodes[0].placeholder = "Bitte eine gültige Gemeinde auswählen";
	result.childNodes[0].childNodes[0].setAttribute('autocomplete',"off");
	result.childNodes[0].innerHTML += "<datalist id='teamList"+type+"'></datalist>";
	result.childNodes[0].childNodes[0].setAttribute('list',"teamList"+type);
	result.childNodes[0].childNodes[0].dataset.valid = false;
	result.childNodes[0].childNodes[0].addEventListener("focusout", (elem) => {if (elem.srcElement.dataset.valid != "true"){elem.srcElement.value="";}});
	result.childNodes[0].childNodes[0].addEventListener("input",  () => {f(type)});
	return result;
}


const datepickerDE = {
	closeText: "Schließen",
	prevText: "&#x3C;Zurück",
	nextText: "Vor&#x3E;",
	currentText: "Heute",
	monthNames: [ "Januar", "Februar", "März", "April", "Mai", "Juni",
	"Juli", "August", "September", "Oktober", "November", "Dezember" ],
	monthNamesShort: [ "Jan", "Feb", "Mär", "Apr", "Mai", "Jun",
	"Jul", "Aug", "Sep", "Okt", "Nov", "Dez" ],
	dayNames: [ "Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag" ],
	dayNamesShort: [ "So", "Mo", "Di", "Mi", "Do", "Fr", "Sa" ],
	dayNamesMin: [ "So", "Mo", "Di", "Mi", "Do", "Fr", "Sa" ],
	weekHeader: "KW",
	dateFormat: "dd.mm.yy",
	firstDay: 1,
	isRTL: false,
	showMonthAfterYear: false,
	yearSuffix: "" };


export function createDatePicker(setData,title,type,viewtype,isContact){
	let result = createDataBox((a,b)=>{},title,type,viewtype,isContact);
	result.childNodes[0].childNodes[0].required = true;
	result.childNodes[0].childNodes[0].type = "text";
	result.childNodes[0].childNodes[0].onclick = () => {
		$.datepicker.setDefaults(datepickerDE);
		$('#'+type).datepicker({ dateFormat: "dd.mm.yy" });
		$('#'+type).on("change",function(){
        	var selected = $(this).val();
        	setData(type,selected,viewtype);
    	});
		$('#'+type).datepicker('show');
	};
	return result;
}


export function createBooleanRadioButtons(setData,title,type,elemIndex,viewType){
	return createRadioButtons(setData,title,["Ja","Nein"],type,elemIndex,viewType);
}


function createP(text){
	let result = document.createElement('p');
	result.appendChild(document.createTextNode(text));
	return result;
}

function createDataBox(setDataFromId,title,type,viewtype,isContact)
{
	let inputContainer = document.createElement('div');
	inputContainer.classList.add("vermInputContainer");

	let groupContainer = document.createElement('div');
	groupContainer.classList.add("group");

	let barInput = document.createElement('input');
	barInput.classList.add("barinput");
	barInput.id=type;

	barInput.addEventListener("input",  () => {setDataFromId(type,viewtype)});
	

	let highlight = document.createElement('span');
	highlight.classList.add("highlight");

	let bar = document.createElement('span');
	bar.classList.add("bar");

	let label = document.createElement('label');
	label.classList.add("barlabel");
	label.innerHTML = title;

	let error = document.createElement('span');
	error.classList.add("vernError");


	groupContainer.appendChild(barInput);
	groupContainer.appendChild(highlight);
	groupContainer.appendChild(bar);
	groupContainer.appendChild(label);

	inputContainer.appendChild(groupContainer);
	inputContainer.appendChild(error);

	return inputContainer;
}

export function createRadioButtons(setData,title,elements,type,elemIndex,viewType){
	
	let inputContainer = document.createElement('div');
	inputContainer.classList.add("vermInputContainer");
	inputContainer.classList.add("radioContainer");

	let radioTitle = createP(title);

	inputContainer.appendChild(radioTitle);

	elements.forEach((element,index) => {
		let radioInput = document.createElement('input');
		radioInput.type = "radio";
		radioInput.id = "radio"+index+elemIndex;
		radioInput.name="radio"+elemIndex;
		radioInput.classList.add(type.toString());
		radioInput.addEventListener("change",  () => {setData(type,element,viewType)});

		let radiolabel = document.createElement("label");
		radiolabel.classList.add("radio");
		radiolabel.htmlFor = "radio"+index+elemIndex;
		radiolabel.innerHTML = element;

		inputContainer.appendChild(radioInput);
		inputContainer.appendChild(radiolabel);

	});
	return inputContainer;
}